<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <HelpFiledStep2
      text="2. Полное наименование проекта"
      :helpText="helpText('UF_NAME')"
    />
    <uf_name />

    <HelpFiledStep2
      text="3. Программа финансовой поддержки"
      :helpText="helpText('UF_SUPPORT_PROG_ID')"
    />
    <uf_support_prog_id />

    <div class="content-title content-mb-14">
      4. В структуре владения уставным капиталом преобладающее участие имеет
      паевой инвестиционный фонд
    </div>
    <uf_is_prevails_mutual_invest_fund></uf_is_prevails_mutual_invest_fund>

    <div class="content-title content-mb-14">
      5. Приобретаемое судно относится к
    </div>
    <div class="row myrow content-mb-42">
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_SHIP_TYPE_ID'
          )
        }"
      >
        <select
          :disabled="$parent.projectDisabled"
          v-model="project.UF_LIZING_SHIP_TYPE_ID"
          class="sel-dropdown i-main-style i-wid-50"
          v-on:change="shipTypeChange"
        >
          <option value=""></option>
          <option
            v-for="item in directory.sp_purchased_ship_lizing"
            v-bind:value="item.ID"
            v-bind:key="item.ID"
            v-text="item.NAME"
          ></option>
        </select>
        <div class="error-text">
          {{
            $parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_LIZING_SHIP_TYPE_ID"
            )
          }}
        </div>
      </div>
    </div>

    <div class="content-title content-mb-14">
      6. Общая стоимость судна (с НДС), тыс. руб.
    </div>
    <div class="row myrow content-mb-42">
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_SHIP_TOTAL_COST'
          )
        }"
      >
        <vue-numeric
          currency=""
          separator="space"
          v-model="project.UF_LIZING_SHIP_TOTAL_COST"
          type="text"
          class="i-main-style i-wid-13"
          :disabled="$parent.projectDisabled"
          v-on:keypress.native="isNumber($event)"
          v-on:paste.native="pasteNumber($event)"
          @input="
            $parent.removeError(
              'PROJECTS',
              'LOGIC',
              'UF_LIZING_SHIP_TOTAL_COST'
            )
          "
        />
        <div class="error-text">
          {{
            $parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_LIZING_SHIP_TOTAL_COST"
            )
          }}
        </div>
      </div>
    </div>

    <div class="content-title content-mb-14">
      7. Размер аванса
    </div>
    <div class="row myrow content-mb-42">
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_SHIP_AVANS_SUM'
          )
        }"
      >
        <input
          type="text"
          class="i-main-style i-wid-13"
          v-model="project.UF_LIZING_SHIP_AVANS_SUM"
          :disabled="$parent.projectDisabled"
          v-on:keypress="isNumber($event)"
          v-on:paste="pasteNumber($event)"
          v-on:input="
            $parent.removeError('PROJECTS', 'LOGIC', 'UF_LIZING_SHIP_AVANS_SUM')
          "
        />
        тыс. руб.
        <!-- процент считает бэк, на форме — только превью -->
        <input
          class="i-main-style i-wid-13"
          disabled
          :value="avansProcent"
        />
        %
        <div class="error-text">
          {{
            $parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_LIZING_SHIP_AVANS_SUM"
            )
          }}
        </div>
        <div class="error-text">
          {{
            $parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_LIZING_SHIP_AVANS_PROCENT"
            )
          }}
        </div>
      </div>
    </div>

    <div class="content-title content-mb-14">
      7.1 Требуемый объем финансирования со стороны Фонда, тыс. руб.
    </div>
    <uf_sum_request></uf_sum_request>

    <div class="content-title content-mb-14">
      8. Расчет процентной ставки
    </div>
    <ship_rate_calc></ship_rate_calc>

    <div class="content-title content-mb-14">
      9. Срок строительства судна, мес.
    </div>
    <div class="row myrow content-mb-42">
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_LIZING_SHIP_CONSTRUCTION_PERIOD'
          )
        }"
      >
        <input
          type="text"
          class="i-main-style i-wid-13"
          v-model="project.UF_LIZING_SHIP_CONSTRUCTION_PERIOD"
          :disabled="$parent.projectDisabled"
          v-on:keypress="isNumber($event)"
          v-on:paste="pasteNumber($event)"
          v-on:input="
            $parent.removeError(
              'PROJECTS',
              'LOGIC',
              'UF_LIZING_SHIP_CONSTRUCTION_PERIOD'
            )
          "
          v-on:change="constructionPeriodChange"
        />
        <div class="error-text">
          {{
            $parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_LIZING_SHIP_CONSTRUCTION_PERIOD"
            )
          }}
        </div>
      </div>
    </div>

    <div class="content-title content-mb-14">
      10. Сроки займа, мес.
    </div>
    <uf_month_return></uf_month_return>

    <div class="content-title content-mb-14">
      11. Информация о судне
    </div>
    <ship_info></ship_info>

    <div class="content-title content-mb-14">
      12. Аннотация проекта
    </div>
    <uf_annotation></uf_annotation>

    <div class="content-title content-mb-14">
      13. Место строительства судна
    </div>
    <place
      :show-dop="false"
      main-label="Основное место строительства судна:"
    ></place>

    <div class="content-title content-mb-14">
      14. Дополнительное место строительства судна
    </div>
    <place
      :show-main="false"
      dop-label="Дополнительное место строительства судна:"
      dop-row-label="Место строительства судна:"
      add-label="Добавить место строительства судна"
    ></place>

    <div class="content-title content-mb-14">
      15. Производитель судна
    </div>
    <ship_company
      model-key="SHIP_MANUFACTURER"
      title="Производитель судна"
      errors-key="shipManufacturerErrors"
      add-label="Добавить производителя судна"
      :show-title="false"
    ></ship_company>

    <div class="content-title content-mb-14">
      16. Оператор судна
    </div>
    <ship_company
      model-key="SHIP_OPERATOR"
      title="Оператор судна"
      errors-key="shipOperatorErrors"
      add-label="Добавить оператора судна"
      :show-title="false"
    ></ship_company>

    <fieldset
      :disabled="isResumeCoordinated"
      style="border: 0; padding: 0; margin: 0;"
    >
      <div class="content-title content-mb-14">
        17. Бюджет проекта в части расходования средств займа Фонда, тыс. руб.
      </div>
      <table class="co-executor" v-if="budgetLoaded">
        <thead>
          <tr>
            <th>№ п/п</th>
            <th>Источники финансирования проекта</th>
            <th>Сумма, тыс. руб.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in budgetSources">
            <td>{{ index + 1 }}</td>
            <td>{{ budgetSourceName(item) }}</td>
            <td
              v-bind:class="{
                'has-error': hasBudgetLizingError(item.ID, 'UF_VALUE')
              }"
            >
              <input
                class="i-main-style i-co-executor-style"
                type="text"
                v-model="project.BUDGET_LIZING.items[item.ID].UF_VALUE"
                :disabled="
                  item.CODE === 'FRP_RESOURCES' || $parent.projectDisabled
                "
                @keyup="removeBudgetLizingError(item.ID, 'UF_VALUE')"
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <th>Итого:</th>
            <td>
              <input
                class="i-main-style i-co-executor-style"
                type="text"
                :value="lizingBudget()"
                disabled
              />
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  </div>
  <!--container-fluid-->
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Place from "@/components/project/form/partial/place";
import uf_is_prevails_mutual_invest_fund from "@/components/project/form/partial/uf_is_prevails_mutual_invest_fund";
import Ship_rate_calc from "@/components/project/form/partial/ship_rate_calc";
import Ship_info from "@/components/project/form/partial/ship_info";
import Ship_company from "@/components/project/form/partial/ship_company";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";

export default {
  name: "step_description_lizing_ships",
  props: {
    step: {
      type: String,
      required: false
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Uf_name,
    Uf_support_prog_id,
    Uf_sum_request,
    Uf_month_return,
    Uf_annotation,
    Place,
    uf_is_prevails_mutual_invest_fund,
    Ship_rate_calc,
    Ship_info,
    Ship_company,
    HelpFiledStep2
  },
  data() {
    return {
      budgetLoaded: false
    };
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "regions",
      "sp_monogorod",
      "start_pokazatel",
      "sp_purchased_ship_lizing",
      "sp_lizing_ship_payment_period"
    ]);

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }
    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store
      .dispatch(FETCH_DIRECTORY, ["type_source_lizing_budget"])
      .then(() => {
        if (
          typeof this.project.BUDGET_LIZING.items === "undefined" ||
          this.project.BUDGET_LIZING.items.length === 0
        ) {
          this.project.BUDGET_LIZING.items = {};
        }
        this.directory.type_source_lizing_budget.forEach(function(item) {
          if (
            typeof this.project.BUDGET_LIZING.items[item.ID] === "undefined"
          ) {
            Vue.set(this.project.BUDGET_LIZING.items, item.ID, {
              ID: 0,
              UF_VALUE: 0
            });
          }
        }, this);
        this.budgetLoaded = true;
      }, this);
  },
  methods: {
    // Тип судна задаёт ставку по займу (пассажирское — 1 %, грузовое, судно
    // рыбопромыслового или технического флота — 3 %), а по ней считается
    // «Общая сумма займа (с учётом процентов)», поэтому пересчёт запускаем так же,
    // как его запускают поля 7.1 и 9.
    shipTypeChange() {
      this.$parent.removeError("PROJECTS", "LOGIC", "UF_LIZING_SHIP_TYPE_ID");
      this.$parent.updateAllSumPercent();
    },
    // Срок строительства судна вычитается из срока займа при расчёте поля
    // «Погашение осн. суммы долга, последних кварталов», а через него влияет
    // на «Общую сумму займа (с учётом процентов)» — пересчёт запускаем так же,
    // как его запускают поля 5, 7.1 и 10.
    constructionPeriodChange() {
      this.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_LIZING_SHIP_CONSTRUCTION_PERIOD"
      );
      this.$parent.updateAllSumPercent();
    },
    helpText(field) {
      const help = this.project.UF_HELP;
      if (help && help.FIELDS && help.FIELDS.STEP2) {
        return help.FIELDS.STEP2[field];
      }
      return "";
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // вставка из буфера: оставляем только цифры, остальное отбрасываем
    pasteNumber: function(evt) {
      evt.preventDefault();
      const buffer = evt.clipboardData || window.clipboardData;
      //поля целочисленные, поэтому дробную часть из буфера отбрасываем,
      //иначе «1 234,56» превратилось бы в 123456
      const digits = String(buffer ? buffer.getData("text") : "")
        .split(/[.,]/)[0]
        .replace(/\D/g, "");
      const input = evt.target;
      if (!input || typeof input.value !== "string") {
        return;
      }
      const from = input.selectionStart === null ? 0 : input.selectionStart;
      const to =
        input.selectionEnd === null ? input.value.length : input.selectionEnd;
      input.value = input.value.slice(0, from) + digits + input.value.slice(to);
      const caret = from + digits.length;
      input.setSelectionRange(caret, caret);
      //уведомляем v-model и vue-numeric — сами они событие вставки не слушают
      input.dispatchEvent(new Event("input", { bubbles: true }));
    },
    hasBudgetLizingError(col, field) {
      const errors = this.$parent.budgetLizingErrors;
      return !!(errors[col] && typeof errors[col][field] !== "undefined");
    },
    removeBudgetLizingError(col, field) {
      const errors = this.$parent.budgetLizingErrors;
      if (errors[col] && typeof errors[col][field] !== "undefined") {
        Vue.delete(errors[col], field);
      }
      return false;
    },
    // Подпись источника: собственные средства организации отдельной строкой не выводятся,
    // их наименование присоединяется к средствам лизинговой компании
    budgetSourceName(item) {
      const org = this.orgBudgetSource;
      if (item.CODE !== "LIZLNG_RESOURCES" || !org) {
        return item.NAME;
      }
      return item.NAME + " / " + org.NAME;
    },
    lizingBudget() {
      let sum = 0;
      this.directory.type_source_lizing_budget.forEach(function(item) {
        if (
          item.CODE === "FRP_RESOURCES" &&
          this.project.BUDGET_LIZING.items[item.ID].UF_VALUE !==
            this.project.UF_SUM_REQUEST
        ) {
          this.project.BUDGET_LIZING.items[
            item.ID
          ].UF_VALUE = this.project.UF_SUM_REQUEST;
        }
        //строка скрыта с формы, поэтому денег в ней быть не должно —
        //иначе "Итого" разойдётся с суммой, которую считает бэк
        if (
          item.CODE === "ORG_RESOURCES" &&
          this.project.BUDGET_LIZING.items[item.ID].UF_VALUE != 0
        ) {
          this.project.BUDGET_LIZING.items[item.ID].UF_VALUE = 0;
        }
        if (this.project.BUDGET_LIZING.items[item.ID].UF_VALUE > 0) {
          sum += parseInt(this.project.BUDGET_LIZING.items[item.ID].UF_VALUE);
        }
      }, this);
      return sum;
    }
  },
  computed: {
    ...mapGetters(["directory"]),

    // «Собственные средства организации» — отдельной строкой в программе не выводятся
    orgBudgetSource() {
      const list = Object.values(this.directory.type_source_lizing_budget || []);
      return list.find(item => item && item.CODE === "ORG_RESOURCES");
    },

    // Источники финансирования, выводимые в пункте 16
    budgetSources() {
      const list = Object.values(this.directory.type_source_lizing_budget || []);
      return list.filter(item => item && item.CODE !== "ORG_RESOURCES");
    },

    // Превью процента аванса. Источник истины — UF_LIZING_SHIP_AVANS_PROCENT
    // из ответа сервера, формула здесь та же, что на бэке.
    avansProcent() {
      const total = Number(this.project.UF_LIZING_SHIP_TOTAL_COST);
      const avans = Number(this.project.UF_LIZING_SHIP_AVANS_SUM);
      if (!total || isNaN(total) || isNaN(avans)) {
        return this.project.UF_LIZING_SHIP_AVANS_PROCENT;
      }
      return ((avans / total) * 100).toFixed(2);
    },
    isResumeCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "rezume_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    }
  }
};
</script>

<style scoped></style>
